import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import { MAIN_ROUTE } from '../utils/constants'
import { resetCurrentUser } from '../../store/slices/currentUserSlice'
import { getApi } from '../../api/api'
import { setChatModalState, setTopicList } from '../../store/slices/chatSlice'
import { setAuthToken } from '../../store/slices/authSlice'

export const useLogout = () => {
  const navigate = useNavigate()
  const [api] = useState(() => getApi())
  const dispatch = useDispatch()

  const logOut = useCallback(async () => {
    try {
      await api.logout()
    } catch (error) {}
    localStorage.removeItem('currentUser')
    localStorage.clear()
    dispatch(setAuthToken(''))
    dispatch(resetCurrentUser())
    dispatch(setChatModalState(false))
    dispatch(setTopicList([]))
    navigate(MAIN_ROUTE)
  }, [api, dispatch, navigate])

  return { logOut }
}
